import CityPageTemplate from "../city-template/CityPageTemplate";
import { saginawTownshipConfig } from "./data";

export default function SaginawTownshipPage() {
  return <CityPageTemplate config={saginawTownshipConfig} />;
}